import INotificationsRepository from 'domain/interfaces/repositories/INotificationsRepository'
import { MarkNotificationsAsReadCommandRequest } from 'domain/entities/notifications'

export const CreateNotificationAsReadCommand = (
  repository: INotificationsRepository,
  data: MarkNotificationsAsReadCommandRequest,
) => {
  return repository.markAsRead(data)
}
